@if (businessTransaction) {
  <app-tabs>
    <app-tab [title]="'meteringpoint.businesstransaction.show.details' | translate">
      <app-value-details
        [collection]="showBusinesstransactionMasterdata"
        [data]="businessTransaction"
      ></app-value-details>
    </app-tab>
    <app-tab [title]="'meteringpoint.businesstransaction.show.message' | translate">
        @if (businessTransaction.rsmText) {
          <div class="flex justify-end mb-2">
            <button
              type="button"
              class="bg-gray-100 dark:bg-dark-hover px-2 py-1 flex items-center gap-1 rounded cursor-pointer active:bg-gray-300 ease-in-out duration-200 text-sm"
              (click)="copyMessageToClipboard()"
            >
              <lucide-angular size="14" [name]="Copy"></lucide-angular>
              {{ 'common.copy' | translate }}
            </button>
          </div>
          <pre class="text-sm font-normal max-w-full text-wrap" [textContent]="businessTransaction.rsmText"></pre>
        }
    </app-tab>
  </app-tabs>
}
